export const loadSessionState = () => {
    try {
        const serializedState = sessionStorage.getItem("state");
        if (serializedState === null) {
            return {};
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return {};
    }
};

export const saveSessionState = (state: any) => {
    try {
        const serializedState = JSON.stringify(state);
        sessionStorage.setItem("state", serializedState);
    } catch (err) {
        // Ignore write errors.
    }
};
